export default function StatBox({ label, value, unit, testId, tone = "default" }) {
  const tones = {
    default: "border-border text-foreground",
    good:    "border-emerald-400/50 text-emerald-700 dark:text-emerald-400 bg-emerald-50/40 dark:bg-emerald-950/20",
    warn:    "border-amber-400/50  text-amber-700  dark:text-amber-400  bg-amber-50/40  dark:bg-amber-950/20",
    bad:     "border-rose-400/50   text-rose-700   dark:text-rose-400   bg-rose-50/40   dark:bg-rose-950/20",
    accent:  "border-brand-gold/50 text-brand-gold bg-brand-gold/5",
  };
  return (
    <div
      className={`border rounded-2xl p-5 bg-card shadow-sm transition-all hover:shadow-md ${tones[tone]}`}
      data-testid={testId}
    >
      <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-muted-foreground mb-2">{label}</div>
      <div className="flex items-baseline gap-1.5">
        <span className="text-3xl md:text-4xl font-black font-mono tabular-nums leading-none">{value}</span>
        {unit && <span className="text-sm font-mono text-muted-foreground">{unit}</span>}
      </div>
    </div>
  );
}
